
import WA_EPS_001 from './wa-eps-001'
import WA_EPS_002 from './wa-eps-002'
import WA_EPS_003 from './wa-eps-003'
import WA_EPS_004 from './wa-eps-004'


import WA_HWF_001 from './wa-hwf-001'
import WA_HWF_002 from './wa-hwf-002'
import WA_HWF_003 from './wa-hwf-003'
import WA_HWF_004 from './wa-hwf-004'
import WA_HWF_005 from './wa-hwf-005'
import WA_HWF_006 from './wa-hwf-006'
import WA_HWF_007 from './wa-hwf-007'
import WA_HWF_008 from './wa-hwf-008'
import WA_HWF_009 from './wa-hwf-009'
import WA_HWF_010 from './wa-hwf-010'
import WA_HWF_011 from './wa-hwf-011'


import WA_MIWO_001 from './wa-miwo-001'
import WA_MIWO_002 from './wa-miwo-002'
import WA_MIWO_003 from './wa-miwo-003'
import WA_MIWO_004 from './wa-miwo-004'
import WA_MIWO_005 from './wa-miwo-005'
import WA_MIWO_006 from './wa-miwo-006'
import WA_MIWO_007 from './wa-miwo-007'
import WA_MIWO_008 from './wa-miwo-008'
import WA_MIWO_009 from './wa-miwo-009'
import WA_MIWO_010 from './wa-miwo-010'
import WA_MIWO_011 from './wa-miwo-011'
import WA_MIWO_012 from './wa-miwo-012'
import WA_MIWO_013 from './wa-miwo-013'
import WA_MIWO_014 from './wa-miwo-014'
import WA_MIWO_015 from './wa-miwo-015'
import WA_MIWO_016 from './wa-miwo-016'
import WA_MIWO_017 from './wa-miwo-017'
import WA_MIWO_018 from './wa-miwo-018'
import WA_MIWO_019 from './wa-miwo-019'
import WA_MIWO_020 from './wa-miwo-020'
import WA_MIWO_021 from './wa-miwo-021'
import WA_MIWO_022 from './wa-miwo-022'
import WA_MIWO_023 from './wa-miwo-023'
import WA_MIWO_024 from './wa-miwo-024'

import WA_OWDVS_001 from './wa-owdvs-001'
import WA_OWDVS_002 from './wa-owdvs-002'
import WA_VHFWDVS_001 from './wa-vhfwdvs-001'

const state = () => ({
  items: {
    WA_EPS_001,
    WA_EPS_002,
    WA_EPS_003,
    WA_EPS_004,

    
    WA_HWF_001,
    WA_HWF_002,
    WA_HWF_003,
    WA_HWF_004,
    WA_HWF_005,
    WA_HWF_006,
    WA_HWF_007,
    WA_HWF_008,
    WA_HWF_009,
    WA_HWF_010,
    WA_HWF_011,

    WA_MIWO_001,
    WA_MIWO_002,
    WA_MIWO_003,
    WA_MIWO_004,
    WA_MIWO_005,
    WA_MIWO_006,
    WA_MIWO_007,
    WA_MIWO_008,
    WA_MIWO_009,
    WA_MIWO_010,
    WA_MIWO_011,
    WA_MIWO_012,
    WA_MIWO_013,
    WA_MIWO_014,
    WA_MIWO_015,
    WA_MIWO_016,
    WA_MIWO_017,
    WA_MIWO_018,
    WA_MIWO_019,
    WA_MIWO_020,
    WA_MIWO_021,
    WA_MIWO_022,
    WA_MIWO_023, 
    WA_MIWO_024,

    WA_OWDVS_001,
    WA_OWDVS_002,

    WA_VHFWDVS_001
  }
})

const getters = {
  items: state => state.items
}

export default {
  namespaced: true,
  state,
  getters
}
